<template>
    <div>
        <v-card elevation="0">
            <v-data-table :headers="headers" :items="items" :items-per-page="5" class="elevation-0" :loading="cartloading" disable-sort>
                <template v-slot:item.actions="{ item }">
                    <v-btn icon color="#21B6A8" @click="viewPosting(item)" class="mr-2" x-small :disabled="deleting || adminmode">
                        <v-icon>mdi-eye</v-icon>
                    </v-btn>
                    <v-btn icon color="#FB6B90" @click="deleteItem(item)" class="mr-2" x-small :loading="deleting" :disabled="adminmode">
                        <v-icon>mdi-delete</v-icon>
                    </v-btn>
                </template>
            </v-data-table>
            <v-card-actions>
                <!--Delete all Cart dialog-->
                <v-dialog v-model="dialogDestoryWarning" width="400px">
                    <template v-slot:activator="{ on, attrs }">
                        <v-btn fab x-small color="#B9B7BD" v-bind="attrs" v-on="on" :disabled="adminmode" elevation="0"><v-icon color="white">mdi-trash-can</v-icon></v-btn>
                    </template>
                    <v-card>
                        <v-toolbar dark color="#FF8300">
                            <v-toolbar-title>Delete all cart items?</v-toolbar-title>
                        </v-toolbar><br />
                        <v-card-text>
                            <br />
                            This action will delete all cart items. Proceed?
                        </v-card-text>
                        <v-divider></v-divider>
                        <v-card-actions>
                        <v-spacer></v-spacer>
                            <v-btn color="#59981A" text @click="dialogDestoryWarning = false">No</v-btn>
                            <v-btn color="#FF8300" text @click="deleteAllItems" :loading="destoryCartloading">Yes</v-btn>
                        </v-card-actions>
                    </v-card>
                </v-dialog>
                <!--End of delete all Cart dialog-->
                <v-spacer></v-spacer>
                <v-btn dark color="#4297A0" @click="startApplication()" rounded :disabled="adminmode" :loading="deleting">
                    Apply
                </v-btn>
            </v-card-actions>
        </v-card>
        <v-dialog
            v-model="dialogView"
            fullscreen
            hide-overlay
            transition="dialog-bottom-transition"
        >
            <v-card>
                <v-toolbar dark color="#004236">
                    <v-toolbar-title>{{ selectedItemView["discipline-resolved"] }}</v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-toolbar-items>
                        <v-btn
                            icon
                            dark
                            @click="dialogView = false"
                        >
                            <v-icon>mdi-close</v-icon>
                        </v-btn>
                    </v-toolbar-items>
                </v-toolbar>
                <ViewPosting v-if="dialogView" :item="selectedItemView" /><br />
            </v-card>
        </v-dialog>
        <v-dialog
            v-model="dialogApply"
            fullscreen
            hide-overlay
            transition="dialog-bottom-transition"
        >
            <v-card>
                <v-toolbar
                    dark
                    color="#004236"
                >
                    <v-toolbar-title>Application</v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-toolbar-items>
                        <v-btn
                            icon
                            dark
                            @click="closeApplicationform"
                        >
                            <v-icon>mdi-close</v-icon>
                        </v-btn>
                    </v-toolbar-items>
                </v-toolbar>
                <ApplicationForm v-if="dialogApply" :posting="postingsList" /><br />
            </v-card>
        </v-dialog>
        <v-snackbar
            v-model="snackbar"
            :color="snackbarcolor"
            :timeout="timeout"
        >
            {{ text }}
        </v-snackbar>
    </div>
</template>
<script>
import ViewPosting from "./ViewPosting.vue"
import ApplicationForm from "./ApplicationForm.vue"
import auth from "../../../js/auth"

export default {
    components: {
        ViewPosting,
        ApplicationForm
    },
    data(){
        return {
            host: location.hostname.toString(),
            headers: [
                {text: 'Discipline', value: 'discipline'},
                { text: 'Discipline (full)', value: 'discipline-resolved' },
                { text: 'Term', value: 'term' },
                { text: 'Type', value: 'type' },
                { text: 'Course(s)', value: 'courses-resolved' },
                { text: 'Due', value: 'endDate' },
                { text: '', value: 'actions' }
            ],
            items: [],
            snackbar: false,
            snackbarcolor: "",
            text: "",
            timeout: 3500,
            cartloading: false,
            selectedItemView: {},
            postingsList: [],
            dialogView: false,
            dialogApply: false,
            deleting: false,
            adminmode: false,
            destoryCartloading: false,
            dialogDestoryWarning: false,
        }
    },
    methods: {
        initialize(){
            const that = this;

            //Session Reading
            if(sessionStorage.getItem('cupeapp_aaa')){
                that.adminmode = true;
            }else {
                that.adminmode = false;
            }
        },
        getCartItems(){
            const that= this;
            that.cartloading = true;

            that.items = [];

            //Session Reading
            let uid = "";
            if(sessionStorage.getItem('cupeapp_aaa')){
                uid = auth.get_impersonated_user()["uid"];
                
            }else {
                uid = auth.get_user()["uid"];
            }

            let api = 'https://'+that.host+'/cgi-bin/cupe-app-api/api.py?mode=getcart&data={"uid": "'+uid+'"}';

            //API calling
            fetch(api)
                .then(function (response) {
                    return response.json();
                })
                .then(function (resultData) {
                    if(!resultData.result.match(/^OK/i)){
                        that.setSnackbar("Warning: "+resultData.message, "#EF6C00"); //orange
                    }else {
                        resultData.data.forEach(element => {
                            if(JSON.stringify(element["posting"]) != "{}"){
                                that.items.push(that.modifyData(element["posting"], element["_itemid"]));
                            }
                        });

                        that.cartloading = false;
                    }
                })
                .catch(function(err){
                    that.setSnackbar("Error: "+err.toString(), "#E57373"); //light red
                })
            //End of API calling
        },
        modifyData(item, itemid){
            const that = this;

            item["discipline"] = item["discipline"].toUpperCase();
            item["discipline-resolved"] = item["courses"][0]["subject-resolved"];
            
            var courselist = "";
            item["courses"].forEach(element => {
                if(element["ssrcomponent"] == "LEC"){
                    courselist += element["catalognbr"]+", ";
                }
            });

            item["term"] = that.resolveTerm(item["strm"]);
            item["courses-resolved"] = courselist.slice(0,-2);
            item["posting-range"] = item["startDate"]+" ~ "+item["endDate"];
            item["_itemid"] = itemid;

            return item
        },
        resolveTerm(stream){
            const that = this;
            let term = stream.slice(-1);
            var year = stream[1]+stream[2];
            var year2 = (parseInt(year)+1).toString();
            var century = (parseInt(stream[0])-1).toString();
            if(term == "9"){
                return "FALL 2"+century+year+"/WINTER 2"+century+year2;
            }else if(term == "5"){
                return "SUMMER 2"+century+year;
            }
        },
        setSnackbar(msg, color){ //Sets Snackbar
            const that = this;
            that.snackbar = true;
            that.snackbarcolor = color;
            that.text = msg;
        },
        viewPosting(item){
            const that = this;
            that.selectedItemView = item;

            that.dialogView = true;
        },
        deleteItem(item){
            const that = this;
            that.deleting = true;
            //Session Reading
            let uid = "";
            if(sessionStorage.getItem('cupeapp_aaa')){
                uid = auth.get_impersonated_user()["uid"];
                
            }else {
                uid = auth.get_user()["uid"];
            }

            let api = 'https://'+that.host+'/cgi-bin/cupe-app-api/api.py?mode=removeCartItem&data={"uid": "'+uid+'", "_itemid":"'+item["_itemid"]+'"}';

            //API calling
            fetch(api)
                .then(function (response) {
                    return response.json();
                })
                .then(function (resultData) {
                    if(!resultData.result.match(/^OK/i)){
                        that.setSnackbar("Warning: "+resultData.message, "#EF6C00"); //orange
                    }else {
                        that.setSnackbar("Deletion successful!", "#18A558"); //green
                        that.deleting = false;
                        that.getCartItems();
                    }
                })
                .catch(function(err){
                    that.setSnackbar("Error: "+err.toString(), "#E57373"); //light red
                })
            //End of API calling
        },
        startApplication(){
            const that= this;
            let courses = [];

            that.items.forEach(element => {
                courses.push({
                    "id": element["id"],
                    "title": element["title"],
                    "strm": element["strm"],
                    "type": element["type"],
                    "courses": element["courses"],
                    "expiry": element["endDate"]
                })
            });

            that.postingsList = courses;
            that.dialogApply = true;
        },
        deleteAllItems(){
            const that = this;
            that.destoryCartloading = true;
            that.cartloading = true;
            //Session Reading
            let uid = "";
            if(sessionStorage.getItem('cupeapp_aaa')){
                uid = auth.get_impersonated_user()["uid"];
                
            }else {
                uid = auth.get_user()["uid"];
            }

            let api = 'https://'+that.host+'/cgi-bin/cupe-app-api/api.py?mode=destroyCart&data={"uid": "'+uid+'"}';

            //API calling
            fetch(api)
                .then(function (response) {
                    return response.json();
                })
                .then(function (resultData) {
                    if(!resultData.result.match(/^OK/i)){
                        that.setSnackbar("Warning: "+resultData.message, "#EF6C00"); //orange
                    }else {
                        that.setSnackbar("Deleted all cart items", "#76B947"); //green
                    }

                    that.destoryCartloading = false;
                    that.dialogDestoryWarning = false;
                    that.getCartItems();
                    that.cartloading = false;
                })
                .catch(function(err){
                    that.setSnackbar("Error: "+err.toString(), "#E57373"); //light red
                })
            //End of API calling
        },
        closeApplicationform(){
            const that = this;
            that.getCartItems();
            that.dialogApply = false;
        }
    },
    created(){
        const that = this;
        that.initialize();
        that.getCartItems();
    }
}
</script>
